import { REGISTER } from 'app/model/register.model';

import { Injectable } from '@angular/core';
import { SharedPdfService } from 'app/services/shared/shared-pdf.service';

@Injectable()
export class OWNERPDFService {
  constructor(private sharedPdfService: SharedPdfService) {}

  generateOwnerInfo(pdfOBJ: REGISTER) {
    return {
      style: 'tableExample',
      table: {
        widths: ['50%', '25%', '25%'],
        body: [
          [
            { text: '1. Director  Name:', style: 'questions' },
            { colSpan: 2, text: '1. Director Street:', style: 'questions' },
            ''
          ],

          [
            {
              text: ' ' + pdfOBJ.ownerinfoArray[0].in_director1_name,
              italics: true
            },
            {
              colSpan: 2,
              text: ' ' + pdfOBJ.ownerinfoArray[0].in_director1_street,
              italics: true
            },
            ''
          ],
          [
            { text: '1.  Director D.O.B:', style: 'questions' },
            { colSpan: 2, text: '1. Director Suburb', style: 'questions' },
            ''
          ],

          [
            {
              text:
                ' ' +
                this.sharedPdfService.dateformat(
                  pdfOBJ.ownerinfoArray[0].in_director1_dob
                ),
              italics: true
            },
            {
              colSpan: 2,
              text: ' ' + pdfOBJ.ownerinfoArray[0].in_director1_suburb,
              italics: true
            },
            ''
          ],
          [
            { text: '1.  Phone:', style: 'questions' },
            { colSpan: 2, text: '1.  Director Country:', style: 'questions' },
            ''
          ],

          [
            {
              text:
                pdfOBJ.ownerinfoArray[0].in_director1_phonecode +
                ' ' +
                pdfOBJ.ownerinfoArray[0].in_director1_phone,
              italics: true
            },
            {
              colSpan: 2,
              text: ' ' + pdfOBJ.ownerinfoArray[0].in_director1_country,
              italics: true
            },
            ''
          ],

          [
            { text: '1.  Drivers Licence No.:', style: 'questions' },
            { colSpan: 2, text: '1.  Director Postcode:', style: 'questions' },
            ''
          ],

          [
            {
              text: ' ' + pdfOBJ.ownerinfoArray[0].in_director1_licence_no,
              italics: true
            },
            {
              colSpan: 2,
              text: ' ' + pdfOBJ.ownerinfoArray[0].in_director1_postcode,
              italics: true
            },
            ''
          ],

          //一共有三组, 接下来还有两组
          [
            { text: '2. Director Name:', style: 'questions' },
            { colSpan: 2, text: '2. Director Street:', style: 'questions' },
            ''
          ],

          [
            {
              text:
                ' ' +
                (pdfOBJ.ownerinfoArray.length < 2
                  ? ' '
                  : pdfOBJ.ownerinfoArray[1].in_director1_name),
              italics: true
            },
            {
              colSpan: 2,
              text:
                ' ' +
                (pdfOBJ.ownerinfoArray.length < 2
                  ? ' '
                  : pdfOBJ.ownerinfoArray[1].in_director1_street),
              italics: true
            },
            ''
          ],
          [
            { text: '2. Director D.O.B:', style: 'questions' },
            { colSpan: 2, text: '2. Director Suburb:', style: 'questions' },
            ''
          ],

          [
            {
              text:
                ' ' +
                (pdfOBJ.ownerinfoArray.length < 2
                  ? ' '
                  : this.sharedPdfService.dateformat(pdfOBJ.ownerinfoArray[1].in_director1_dob)),
              italics: true
            },
            {
              colSpan: 2,
              text:
                ' ' +
                (pdfOBJ.ownerinfoArray.length < 2
                  ? ' '
                  : pdfOBJ.ownerinfoArray[1].in_director1_suburb),
              italics: true
            },
            ''
          ],
          [
            { text: '2. Phone:', style: 'questions' },
            { colSpan: 2, text: '2. Director Country:', style: 'questions' },
            ''
          ],

          [
            {
              text:
                ' ' +
                (pdfOBJ.ownerinfoArray.length < 2
                  ? ' '
                  : pdfOBJ.ownerinfoArray[1].in_director1_phonecode +
                    ' ' +
                    pdfOBJ.ownerinfoArray[1].in_director1_phone),
              italics: true
            },
            {
              colSpan: 2,
              text:
                ' ' +
                (pdfOBJ.ownerinfoArray.length < 2
                  ? ' '
                  : pdfOBJ.ownerinfoArray[1].in_director1_country),
              italics: true
            },
            ''
          ],
          [
            { text: '2. Drivers Licence No.:', style: 'questions' },
            { colSpan: 2, text: '2. Director Postcode:', style: 'questions' },
            ''
          ],

          [
            {
              text:
                ' ' +
                (pdfOBJ.ownerinfoArray.length < 2
                  ? ' '
                  : pdfOBJ.ownerinfoArray[1].in_director1_licence_no),
              italics: true
            },
            {
              colSpan: 2,
              text:
                ' ' +
                (pdfOBJ.ownerinfoArray.length < 2
                  ? ' '
                  : pdfOBJ.ownerinfoArray[1].in_director1_postcode),
              italics: true
            },
            ''
          ],

          //一共三组 还有一组
          [
            { text: '3. Director Name:', style: 'questions' },
            { colSpan: 2, text: '3. Director Street:', style: 'questions' },
            ''
          ],

          [
            {
              text:
                ' ' +
                (pdfOBJ.ownerinfoArray.length < 3
                  ? ' '
                  : pdfOBJ.ownerinfoArray[2].in_director1_name),
              italics: true
            },
            {
              colSpan: 2,
              text:
                ' ' +
                (pdfOBJ.ownerinfoArray.length < 3
                  ? ' '
                  : pdfOBJ.ownerinfoArray[2].in_director1_street),
              italics: true
            },
            ''
          ],
          [
            { text: '3. Director D.O.B:', style: 'questions' },
            { colSpan: 2, text: '3. Director Suburb:', style: 'questions' },
            ''
          ],

          [
            {
              text:
                ' ' +
                (pdfOBJ.ownerinfoArray.length < 3
                  ? ' '
                  : this.sharedPdfService.dateformat(pdfOBJ.ownerinfoArray[2].in_director1_dob)),
              italics: true
            },
            {
              colSpan: 2,
              text:
                ' ' +
                (pdfOBJ.ownerinfoArray.length < 3
                  ? ' '
                  : pdfOBJ.ownerinfoArray[2].in_director1_suburb),
              italics: true
            },
            ''
          ],
          [
            { text: '3. Phone:', style: 'questions' },
            { colSpan: 2, text: '3. Director Country:', style: 'questions' },
            ''
          ],

          [
            {
              text:
                ' ' +
                (pdfOBJ.ownerinfoArray.length < 3
                  ? ' '
                  : pdfOBJ.ownerinfoArray[2].in_director1_phonecode +
                    ' ' +
                    pdfOBJ.ownerinfoArray[2].in_director1_phone),
              italics: true
            },
            {
              colSpan: 2,
              text:
                ' ' +
                (pdfOBJ.ownerinfoArray.length < 3
                  ? ' '
                  : pdfOBJ.ownerinfoArray[2].in_director1_country),
              italics: true
            },
            ''
          ],
          [
            { text: '3. Drivers Licence No.:', style: 'questions' },
            { colSpan: 2, text: '3. Director Postcode:', style: 'questions' },
            ''
          ],

          [
            {
              text:
                ' ' +
                (pdfOBJ.ownerinfoArray.length < 3
                  ? ' '
                  : pdfOBJ.ownerinfoArray[2].in_director1_licence_no),
              italics: true
            },
            {
              colSpan: 2,
              text:
                ' ' +
                (pdfOBJ.ownerinfoArray.length < 3
                  ? ' '
                  : pdfOBJ.ownerinfoArray[2].in_director1_postcode),
              italics: true
            },
            ''
          ]
        ]
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/services/pdf/ownerinfopdf.generation.ts